export const NEW_SLIDE_MARKETPLACE_FLAG = 'AHA-42884-new-slide-market-place'

export const NEW_SLIDE_MARKETPLACE_VARIANTS = {
  TREATMENT: 'Treatment',
  CONTROL_1: 'Control1',
  CONTROL_2: 'Control2',
}
